// extracted by mini-css-extract-plugin
module.exports = {"header":"Dashboard_header__1TFrB","d":"Dashboard_d__X9hiS","linktext":"Dashboard_linktext__2Le_f"};